import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import utils from "@utils";

const CallOffReport = ({ rows: { Items }, TimeZoneId }) => {
	const { lang } = global;

	// FE-1255: "legacy" class added to this table only for consistent appearance with other reports
	// Changed from Bootstrap grid to table because grid caused text overflow issues with smaller columns and was not mobile-friendly
	return (
		<div className="table-responsive legacy">
			<table className="table">
				<thead>
					<tr>
						<th>{lang.t("Job ID")}</th>
						<th>{lang.t("Officer")}</th>
						<th>{lang.t("Officer Email")}</th>
						<th>{lang.t("Client")}</th>
						<th>{lang.t("Job Date")}</th>
						<th>{lang.t("Location")}</th>
						<th>{lang.t("Completed Call-off Date")}</th>
						<th>{lang.t("Voided")}</th>
						<th>{lang.t("Call-off Type")}</th>
						<th>{lang.t("Reason")}</th>
						<th>{lang.t("Comments")}</th>
					</tr>
				</thead>
				<tbody>
					{Items.map((officer, index) => (
						/* list won't mutate so it's ok to use indexes as keys for now */
						/* eslint-disable */
						<tr
							key={`calloff_${officer.OfficerId}_${officer.JobEventId}_${officer.JobId}_${index}`}
						>
							<td>
								<Link to={`/jobs/${officer.JobEventId}`}>{officer.JobEventId}</Link>
							</td>
							<td>
								<Link to={`/officers/${officer.OfficerId}`}>
									{officer.OfficerName}
								</Link>
							</td>
							<td>{officer.OfficerEmail}</td>
							<td>{officer.ClientName}</td>
							<td>
								{utils.formatDate(
									new Date(`${officer.JobStartDateTime}Z`),
									"en-US",
									TimeZoneId,
								)}
							</td>
							<td>{officer.Location}</td>
							<td>
								{utils.formatDate(
									new Date(`${officer.CallOffDate}Z`),
									"en-US",
									TimeZoneId,
								)}
							</td>
							<td>{officer.Voided ? "Yes" : "No"}</td>
							<td>{officer.CallOffType}</td>
							<td>{officer.Reason}</td>
							<td>{officer.Comments}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

CallOffReport.propTypes = {
	rows: PropTypes.object.isRequired,
	TimeZoneId: PropTypes.string,
};

CallOffReport.defaultProps = {
	TimeZoneId: undefined,
};

export default CallOffReport;
